import { Spin, Space, Input } from "antd";
import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import Page from "_components/Page";
import total from "img/dasboard-weight/dashboard.svg";
import { zoneService } from "_services";
import NumberInfo from "../components/NumberInfo";
import "../../../layouts/layout.scss";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function OtrHome() {
  const [loading, setLoading] = useState(false);
  const [loadingZones, setLoadingZones] = useState(false);
  const [zones, setZones] = useState([]);
  const [error, setError] = useState(null);
  const { Search } = Input;
  const locationSummaryTitles = [
    "boxs",
    "stock",
    "gross",
    "total_cones",
    "gross",
    "total_cones2",
    "boxs2",
    "stock2",
  ];

  useEffect(() => {
    setLoadingZones(true);
    zoneService
      .search("")
      .then((data) => {
        setZones(data.content);
        setLoadingZones(false);
      })
      .catch((error) => {
        setLoadingZones(false);
        setError(error);
      });
  }, []);

  return (
    <Page className="dashboard" error={error}>
      <Spin tip="Loading..." spinning={loading}>
        <div className="wrapper">
          <div className="widgets">
            <Spin tip="Loading..." spinning={loadingZones}>
              <div className="widget">
                {zones.map((summary, i) => {
                  return (
                    <NumberInfo
                      key={summary.id}
                      title={summary.name}
                      categoryTitle="Total Pallets"
                      categoryTitle1="Total Quantity"
                      categoryTitle2="Total CBM"
                      gap={8}
                      totalItems={summary.totalStocks}
                      numberTitle={locationSummaryTitles[i]}
                      iconImage={total}
                      totalQuantity={Number(summary.totalQuantity)}
                      totalCbm={Number(summary.totalCbm)}
                    />
                  );
                })}
              </div>
            </Spin>
          </div>
        </div>
      </Spin>
    </Page>
  );
}

export default OtrHome;
